<template>
  <yams-template>
    <template #header>
      <div class="mr-5">
        <h4 class="text-primary font-weight-bold">Factures ({{ lines }})</h4>
      </div>
      <div class="mr-4">
        <NavComptabilite></NavComptabilite>
      </div>
      <div class="btn-group page-nav mr-4" role="group" aria-label="Basic example">
        <button type="button" class="btn " @click.prevent="changeAffichage('table')"
          :class="{ 'active': affichage === 'table' }">
          <i class="fa-solid fa-bars"></i>
        </button>
        <button type="button" class="btn " @click.prevent="changeAffichage('card')"
          :class="{ 'active': affichage === 'card' }">
          <i class="fa-solid fa-border-all"></i>
        </button>
      </div>
      <button type="button" class="btn-yams btn-active" @click="openCreateModal()">
        Ajouter une facture <i class="fa-solid fa-plus"></i>
      </button>
    </template>
    <template #content>
      <div class="card mb-5">
        <div class="card-body p-1">
          <DataTableBackend :key="key" url="/api/factures" :columns="columns"
            :view-mode="affichage" :table="table" v-on:set-total-records="updateLines"
            @row-click="openShowModal" @set-selected-rows="getSelection">
            <template #statut="slotProps">
              <span class="p-2 rounded-pill badge" :class="{
                'badge-secondary': slotProps.data.statut === 'Brouillon',
                'badge-success': slotProps.data.statut === 'Soldé',

              }">
                {{ slotProps.data.statut }}
              </span>
            </template>
          </DataTableBackend>
        </div>
      </div>
    </template>
  </yams-template>
</template>

<script>
import $ from "jquery"
import { defineComponent } from 'vue';
import FormFacture from "@/views/comptabilite/factures/FormFacture.vue";
import ShowFacture from '@/views/comptabilite/factures/ShowFacture.vue';
import NavComptabilite from '@/views/comptabilite/NavComptabilite.vue'

export default defineComponent({
  components: { NavComptabilite },
  name: 'IndexFacture',
  data() {
    return {
      key: 1,
      lines: 0,
      affichage: "table",
      selection: [],
      isLoading: true,
      table: 'factures',
      columns: [
        {
          key: 'date_operation',
          label: 'Date de facturation',
          format: 'date',
          exportable: true
        },
        {
          key: 'client_nom',
          label: 'Client',
          exportable: true,
          sortable: true
        },
        {
          key: 'type',
          label: 'Type',
          exportable: true,
          sortable: true
        },
        {
          key: 'total_ttc',
          label: 'Net à payer',
          format: 'money',
          exportable: true
        },
        {
          key: 'statut',
          label: 'Statut',
          // format: 'state'
        }
      ]
    };
  },
  methods: {
    changeAffichage(type) {
      this.affichage = type;
      this.key++
    },
    getSelection(selection) {
      this.selection = selection
    },
    openShowModal(objData) {
      this.$dialog.open(ShowFacture, {
        props: {
          header: "Facture #" + objData.id,
          style: {
            width: '80vw'
          },
          modal: true
        },
        data: objData
      });
    },
    openCreateModal() {
      this.$dialog.open(FormFacture, {
        props: {
          header: "Nouvelle facture",
          style: {
            width: '60vw'
          },
          modal: true
        }
      });
    },
    updateLines(nb_lines) {
      this.lines = nb_lines
    }
  },

});
</script>